import { getCurrentInstance } from "vue";

export function useStore() {
    const instance = getCurrentInstance()
    return {
        get store() {
            return instance.proxy.$store
        }
    }
}
